import CodeMirror from '@uiw/react-codemirror'
import { StreamLanguage } from '@codemirror/language'
import { stex } from '@codemirror/legacy-modes/mode/stex'
import { EditorView } from '@codemirror/view'
import styles from './CodeEditor.module.css'

interface CodeEditorProps {
  value: string
  onChange: (value: string) => void
  isCompiling?: boolean
}

// Custom theme to match app aesthetics
const customTheme = EditorView.theme({
  '&': {
    height: '100%',
    fontSize: '13px',
    fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace',
  },
  '.cm-content': {
    padding: '1rem 0',
  },
  '.cm-line': {
    padding: '0 1rem',
  },
  '.cm-gutters': {
    backgroundColor: 'transparent',
    borderRight: '1px solid rgba(0, 0, 0, 0.06)',
    color: 'var(--text-muted)',
  },
  '.cm-activeLineGutter': {
    backgroundColor: 'rgba(30, 90, 65, 0.05)',
  },
  '.cm-activeLine': {
    backgroundColor: 'rgba(30, 90, 65, 0.03)',
  },
  '&.cm-focused .cm-cursor': {
    borderLeftColor: 'var(--accent)',
  },
  '&.cm-focused .cm-selectionBackground, ::selection': {
    backgroundColor: 'rgba(30, 90, 65, 0.15)',
  },
})

export function CodeEditor({ value, onChange, isCompiling }: CodeEditorProps) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.filename}>resume.tex</span>
        {isCompiling && (
          <span className={styles.status}>
            <span className={styles.statusDot} />
            Compiling...
          </span>
        )}
      </div>
      <div className={styles.editorWrapper}>
        <CodeMirror
          value={value}
          onChange={onChange}
          extensions={[StreamLanguage.define(stex), customTheme]}
          basicSetup={{
            lineNumbers: true,
            highlightActiveLineGutter: true,
            highlightActiveLine: true,
            foldGutter: true,
            bracketMatching: true,
            closeBrackets: true,
            autocompletion: false,
          }}
          className={styles.editor}
        />
      </div>
    </div>
  )
}
